import React from 'react';
import './ChatSuggestion.css';


export interface props {
    handleSuggestion: (e: React.MouseEvent<HTMLDivElement>, text: string) => void
    suggestionString: string
    disabled: boolean
}

const ChatSuggestion = ({ handleSuggestion, suggestionString, disabled }: props) => {

    return (
        <div className={`chat-message suggestion ${disabled ? 'disabled' : ''}`} onClick={(e) => handleSuggestion(e, suggestionString)}>
            {suggestionString}
        </div>
    );
};

export default ChatSuggestion;
